import { cn } from '@/core/lib/utils/cn'
import { RemoteImage } from '@/core/ui/atoms/remote-image'
import { SliderModel } from '@/features/content/types/models/slider.model'

type Props = {
  className?: string
  slideClassName?: string
  renderIcon?: (src: string) => React.ReactNode
  slides: SliderModel[]
}

export const Features: React.FC<Props> = async ({
  className = '',
  renderIcon,
  slideClassName = '',
  slides,
}) => {
  if (!slides || slides.length === 0) {
    return null
  }

  return (
    <section
      className={cn(
        'flex flex-col items-start justify-between gap-8 md:flex-row',
        className,
      )}
    >
      {slides.map(item => (
        <div
          key={`${item.id}-${item.title}-${item.description}`}
          className={cn(
            'text-navy flex w-fit flex-1 items-start gap-2',
            slideClassName,
          )}
        >
          {renderIcon ? (
            renderIcon(item.image.url)
          ) : (
            <RemoteImage
              alt=''
              width={28}
              height={28}
              src={item.image.url}
              className='row-span-3 -mt-px h-7 w-7 object-cover sm:mt-1'
            />
          )}
          <div className='flex flex-col'>
            <h4 className='col-span-2 font-bold'>{item.title}</h4>
            <span
              className='col-span-2 row-span-2'
              dangerouslySetInnerHTML={{ __html: item.description }}
            />
          </div>
        </div>
      ))}
    </section>
  )
}
